import {
  LIST_ORGANIZATIONS_ERROR,
  LIST_ORGANIZATIONS_START,
  LIST_ORGANIZATIONS_SUCCESS,
} from 'constants/action-types/organizations/listOrganizations';

export default (state, { type, payload }) => {
  switch (type) {
    case LIST_ORGANIZATIONS_START:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
        },
      };
    case LIST_ORGANIZATIONS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: payload,
          loading: false,
        },
      };
    case LIST_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          items: payload.data,
          meta: payload.meta,
          loading: false,
        },
      };
    default:
      return null;
  }
};
